import { authenticatedPatch } from '../../../api/request';

export const updateDoctorPassword = (data, onFail) => {
  return authenticatedPatch(`/doctor-data/update-password`, onFail, data);
};
